/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_bell': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<g data-name="Group 700"><path pid="0" d="M15.014 14H9.988a2.01 2.01 0 01-4.021 0H.937a.965.965 0 01-.9-.7 1.064 1.064 0 01.3-1.1A4.019 4.019 0 001.947 9V6a6.031 6.031 0 0112.062 0v3a4.019 4.019 0 001.608 3.2.944.944 0 01.3 1.1.965.965 0 01-.903.7z" data-name="Path 1" _fill="#959ba6" fill-rule="evenodd"/></g>'
  }
})
